import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { FormControl, FormGroup } from '@angular/forms'
import { PdfChart } from '../../shared/pdfChart'
import { ExportExcelService } from 'app/service/export-excel.service'
import { CpmService } from '../../service/cpm.service'
import { Subject } from 'rxjs/Subject'
import 'rxjs/add/operator/map'
import { DataTableDirective } from 'angular-datatables'
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-asean-exchanges',
  templateUrl: './asean-exchanges.component.html',
  styleUrls: ['./asean-exchanges.component.scss']
})
export class AseanExchangesComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  dtTrigger: Subject<any> = new Subject()
  marketCapTableOptions: DataTables.Settings = {}
  capRaisedTableOptions: DataTables.Settings = {}
  radioExchanges
  ipoValue = ''
  round = 1
  ipoCountry
  ipoCountry2
  ipoCompany
  rank
  ipoMarket
  ipoMarket2
  dataProvider
  listExchange
  dataProvider2
  ipoNewvalue
  ipoNewvalue2
  ipoFundRaised
  ipoFundRaised2
  capTableOptions
  ipoYear
  ipoYear2
  getPrint
  countryList = []
  ipoAsofdate
  year
  tradingDate
  form: FormGroup
  pdfChart: PdfChart = new PdfChart()
  listTotal
  initTableFirstTime = false

  constructor(
    private activatedRoute: ActivatedRoute,
    private excelService: ExportExcelService,
    private cpmService: CpmService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    const { ipoValue } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print
    this.pdfChart.setPdf(pdf)
    ipoValue === undefined
      ? (this.ipoValue = 'c')
      : (this.ipoValue = ipoValue.toLowerCase())

    this.radioExchanges = [
      { value: 'c', des: 'Capital raised' },
      { value: 'm', des: 'Market cap' }
    ]

    this.form = new FormGroup({
      ipoValue: new FormControl(this.ipoValue)
    })

    this.onChangeData()
  }

  async onChangeData() {
    if (this.initTableFirstTime) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }

    this.capRaisedTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      order: [
        [1, 'desc'],
        [2, 'desc'],
        [3, 'desc'],
        [4, 'desc'],
        [5, 'desc'],
        [6, 'desc']
      ],
      columnDefs: [
        { targets: 0, orderable: false },
        { targets: 1, orderable: false },
        { targets: 2, orderable: false },
        { targets: 3, orderable: false },
        { targets: 4, orderable: false },
        { targets: 5, orderable: false },
        { targets: 6, orderable: false },
        { targets: 7, visible: false }
      ],
      orderFixed: [7, 'asc']
    }

    await this.cpmService
      .getExchangeTopIpo(
        this.form.get('ipoValue').value,
        this.rank
      )
      .then(allData => {
        this.ipoAsofdate = allData.asOfDate
        const data = []

        data.push(...allData.exchange)

        this.dataProvider = data

        this.ipoCompany = this.dataProvider.map(
          companyIpo => companyIpo.companyName
        )
        this.ipoCountry = this.dataProvider.map(
          countryIpo => countryIpo.country
        )
        this.ipoFundRaised = this.dataProvider.map(
          fundRaisedIpo => fundRaisedIpo.fundRaised
        )
        this.ipoMarket = this.dataProvider.map(marketIpo => marketIpo.market)
        this.ipoNewvalue = this.dataProvider.map(
          newipoValue => newipoValue.newIpo
        )
        this.ipoYear = this.dataProvider.map(yearIpo => yearIpo.year)

        this.ipoCountry = this.ipoCountry.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])

        this.listTotal = this.ipoCountry.map(county => {
          const listValue = []
          const total = {}
          total['county'] = county
          let name
          const list = this.dataProvider.filter(obj => obj.country === county)
          list.map(values => {
            listValue.push(values.fundRaised)
            name = values.name
          })
          const sum = listValue.reduce((a, b) => a + b, 0)
          total['name'] = name
          total['fundRaised'] = sum
          return total
        })

        this.dataProvider = this.dataProvider.filter(dataObj => !!dataObj.companyName)

      })

    await this.cpmService
      .getExchangeIpo(
        this.form.get('ipoValue').value,
        this.round
      )
      .then(allData => {
        this.ipoAsofdate = allData.asOfDate
        const data = []
        data.push(...allData.exchange)
        this.dataProvider2 = data

        this.ipoCountry2 = this.dataProvider2.map(
          countryIpo => countryIpo.country
        )
        this.ipoFundRaised2 = this.dataProvider2.map(
          fundRaisedIpo => fundRaisedIpo.fundRaised === null ? 0 : fundRaisedIpo.fundRaised
        )
        this.ipoMarket2 = this.dataProvider2.map(marketIpo => marketIpo.market)
        this.ipoNewvalue2 = this.dataProvider2.map(
          newipoValue => newipoValue.newIpo === null ? 0 : newipoValue.newIpo
        )
        this.ipoYear2 = this.dataProvider2.map(yearIpo => yearIpo.year)

        this.ipoCountry2 = this.ipoCountry2.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])
      })
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

  getOrder(country) {
    const data = this.countryList.find(obj => obj.country === country)
    return data.value
  }

  numberToNoDecimal(num) {
    return Number(parseFloat(num).toFixed(0)).toLocaleString('en')
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/asean-exchanges/asean-exchanges.component.ts